<template>
    <div class="md-layout" v-if="isAddShow">
        <div class="md-layout-item md-size-20 no-padding">
            <md-card>
                <md-card-header md-alignment="space-between">
                    <h4 class="title">
                        <md-icon>publish</md-icon>
                        일괄 처리 입력
                    </h4>
                </md-card-header>
                <md-card-content>
                    <div class="flex-div">
                        <h5 class="title">엑셀 업로드</h5>

                        <div class="inline-flex mb10">
                            <input type="file" class="hidden-input-file" id="uploadExcelFileInput" accept=".xlsx">
                            <input type="text" v-model="uploadExcelFileName" disabled>
                          <button @click="onClickSearchNewExcel">
                            <md-icon>search</md-icon>
                          </button>
                        </div>

                        <md-button class="md-success md-sm full-size-button" @click="uploadExcelFile" :disabled="!uploadFiles">
                            <md-icon>publish</md-icon>엑셀 업로드
                        </md-button>
                    </div>
                </md-card-content>
            </md-card>
        </div>
        <div class="md-layout-item md-size-80 no-padding">
            <md-card>
                <md-card-header md-alignment="space-between">
                    <h4 class="title">
                        <md-icon>assignment</md-icon>임원진 일괄 처리
                    </h4>
                </md-card-header>
                <md-card-content>
                    <div class="table-header-info">
                        <div>총 {{ total }} 건의 데이타 업로드 대상이 있습니다.</div>
                        <div>
                            <select v-model="pagination.perPage" name="pages">
                                <option v-for="item in pagination.perPageOptions" :key="item" :label="item" :value="item">
                                {{ item }}
                                </option>
                            </select>
                        </div>
                    </div>

                    <grid ref="excelDataList"
                        :data="gridProps.data"
                        :columns="gridProps.columns"
                        :options="gridProps.options"
                        :theme="gridProps.theme"
                        :rowHeaders="gridProps.rowHeaders"
                        :columnOptions="gridProps.columnOptions"
                        :language="gridProps.lang"
                    ></grid>

                </md-card-content>
                <md-card-actions md-alignment="space-between">
                    <div>
                        <md-button class="md-info md-sm" @click="saveExcelFile">
                            <md-icon>check</md-icon>저 장
                        </md-button>
                    </div>
                </md-card-actions>
            </md-card>
        </div>
    </div>
</template>

<script>

import URL_CONST from "@/kuaa/kuaa-url-const";
import kuaaApi from "@/kuaa/kuaa-api";

import Swal from "sweetalert2";

import { Grid } from '@toast-ui/vue-grid';
import 'tui-grid/dist/tui-grid.css';
import 'tui-pagination/dist/tui-pagination.css';
import kuaaFnc from "@/kuaa/kuaa-comm-func";

export default {
  name: "ExcutiveAddComp",
  props: {
    isShow : {
      type: Boolean,
      default: false
    },
    orgGbList: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  components: {
    grid: Grid
  },

  created() {
      this.initGrid();
  },

  computed: {
      isAddShow: function(){
          return this.isShow;
      },
      total: function() {
          return this.pagination.total;
      }
  },

  watch: {
  },

  data() {
    return {
        pagination: {
          page: 1,
          perPage: 20,
          currentPage: 1,
          perPageOptions: [20, 50, 100, 200, 500],
          total: 0
        },

      uploadFiles: null,
      uploadExcelFileName: null,
    }
  },
  methods: {

    initGrid() {
      this.gridProps = kuaaFnc.setGridInit(null, false, this.pagination);
      this.gridProps['el'] = this.$refs.excelDataList;
      this.gridProps['columns']= [
          {header: '교우번호', name: 'memberNo'},
          {header: '취임일', name: 'erectDate'},
          {header: '퇴임일', name: 'expireDate'},
          {header: '직위코드', name: 'levelCd'},
          {header: '대수', name: 'reign'},
          {header: '대학코드', name: 'collegeCd'},
          {header: '지부/분회ID', name: 'branchId'},
          {header: '설명', name: 'remark'}
          //{header: '분담금', name: 'amount'},
          //{header: '이슈구분', name: 'issueGb'},
          //{header: '이슈구분2', name: 'reissueGb'},
          //{header: '신용구분', name: 'trustGb'},
          //{header: '반송구분', name: 'sendbackGb'},
        ];
      this.gridProps['options'].bodyHeight = 150;
    },

    onClickSearchNewExcel(e) {
      e.preventDefault();
      let input = document.getElementById("uploadExcelFileInput");
      input.onchange = e => {
        let file = e.target.files[0];
        this.uploadExcelFileName = file.name;
        this.uploadFiles = file;
      };
      input.click();
    },


    /**
     *
     */
    uploadExcelFile() {
      let formData = new FormData();
      formData.append("files", this.uploadFiles);

      kuaaApi.sendServerMixData(
          URL_CONST.EXCEL_FILE_UPLOAD,
          formData,
          "post",
          res=>{
            this.pagination.total = res.data.data.contents.length;
            this.$refs.excelDataList.invoke("resetData", res.data.data.contents);
          }
      );
    },

    saveExcelFile(){
      let gridDatas = this.$refs.excelDataList.invoke("getData");

      kuaaApi.sendServer(
          URL_CONST.SAVE_ORG_LIST,
          this.$refs.excelDataList.invoke("getData"),
          "post",
          response => {
            kuaaFnc.showSwal("엑셀파일 업로드", '저장 처리 되었습니다.');
          }
      );
    }
  }
}
</script>

<style lang="css" scoped>

</style>
